import { z } from 'zod';

/** Languages the app's screens are translated into. */
export const APP_LOCALES = ['en', 'es'] as const;
export type AppLocale = (typeof APP_LOCALES)[number];
export const AppLocaleSchema = z.enum(APP_LOCALES);

export function isAppLocale(x: unknown): x is AppLocale {
  return typeof x === 'string' && (APP_LOCALES as readonly string[]).includes(x);
}

/**
 * The first supported language in a list of BCP 47 tags (such as `navigator.languages`), matching on the
 * language part only ("es-CO" → "es"). English when none match.
 */
export function matchLocale(tags: readonly (string | null | undefined)[]): AppLocale {
  for (const tag of tags) {
    const lang = (tag ?? '').toLowerCase().split(/[-_]/)[0];
    if (isAppLocale(lang)) return lang;
  }
  return 'en';
}
